"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidCognitoRole = exports.getCognitoRolesFrom = exports.getCognitoRoles = void 0;
const enums_1 = require("../enums");
const getCognitoRoles = () => [
    enums_1.CognitoRole.STUDENT,
    enums_1.CognitoRole.TEACHER,
    enums_1.CognitoRole.SCHOOL_ADMIN,
    enums_1.CognitoRole.DISTRICT_ADMIN,
    enums_1.CognitoRole.GM_AUTHOR,
    enums_1.CognitoRole.GM_DIS,
    enums_1.CognitoRole.GM_STAFF,
    enums_1.CognitoRole.GM_DCST_AGENT,
    enums_1.CognitoRole.GM_SUPER,
    enums_1.CognitoRole.GM_PS,
];
exports.getCognitoRoles = getCognitoRoles;
const getCognitoRolesFrom = (values = []) => {
    const roles = (0, exports.getCognitoRoles)();
    return roles.filter((v) => values.indexOf(v) >= 0);
};
exports.getCognitoRolesFrom = getCognitoRolesFrom;
const getValidCognitoRole = (value) => {
    const roles = (0, exports.getCognitoRoles)();
    return roles.includes(value)
        ? roles.find((v) => v === value)
        : undefined;
};
exports.getValidCognitoRole = getValidCognitoRole;
//# sourceMappingURL=enum.helper.js.map